module.exports = __webpack_public_path__ + "static/img/app_bg2.b2c6a8d1.png";